export const globalErrorHandler = (jsonResponse) => {
    if (jsonResponse.Errored) {
        throw new Error(jsonResponse.Message);
    }
    else {
        return jsonResponse;
    }
}